import classNames from 'classnames';
import React from 'react';
import { DataGridCellSkeleton } from "./components/DataGridCell/DataGridCell.skeleton.js";
import { DataGridHeaderCellSkeleton } from "./components/DataGridHeaderCell/DataGridHeaderCell.skeleton.js";
import { DataGridRowSkeleton } from "./components/DataGridRow/DataGridRow.skeleton.js";
import styles from "./DataGrid.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DataGridSkeleton({
  rowAlternating,
  rowHeight = 60,
  rowCount = 10,
  columnCount
}) {
  let key = 0;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      gridTemplateColumns: new Array(columnCount).fill('1fr').join(' '),
      '--data-grid-row-height': `${rowHeight}px`
    },
    className: classNames(styles.dataGrid, {
      [styles.isAlternating]: rowAlternating
    }),
    children: [new Array(columnCount).fill(0).map((_, index) => /*#__PURE__*/_jsx(DataGridHeaderCellSkeleton, {
      isAlternating: rowAlternating,
      isFirst: index === 0,
      isLast: index === columnCount - 1
    }, key++)), new Array(rowCount).fill(0).map((_, rowIndex) => /*#__PURE__*/_jsx(DataGridRowSkeleton, {
      rowAlternating: rowAlternating,
      children: new Array(columnCount).fill(0).map((_, columnIndex) => /*#__PURE__*/_jsx(DataGridCellSkeleton, {
        isLastRow: rowIndex === rowCount - 1,
        isFirst: columnIndex === 0,
        isLast: columnIndex === columnCount - 1
      }, columnIndex))
    }, key++))]
  });
}